import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Grid, Typography, ThemeProvider } from "@material-ui/core";
import { addRegisteredLayout } from "../layoutDescriptions";
import { Panel } from "../../../panel";
import { DirwebStepper } from "./DirwebStepper";
import { useStyles, actionsTheme, mainTheme } from "./styles";
import { usePageState } from "../../../PageContext";
import clsx from "clsx";
import { useTenant } from "@ploy-ui/tenants";
import { useIntl } from "react-intl";
const mainPanelSettings = {
    editableOptions: {
        title: false,
        elevation: true,
        square: true
    }
};
const panelSettings = {
    main: mainPanelSettings,
    actions: {
        editableOptions: {
            desktopViewForMobile: true
        }
    }
};
addRegisteredLayout({
    name: "DirwebLong",
    displayName: "DirwebLong",
    panels: panelSettings,
    pageUri: true,
    pageDescription: true,
    hasHeaderIcon: true
});
export const DirwebLong = (props) => {
    const { description, panels, stepper, headerIconName } = props;
    const { main, actions } = panels;
    const { step } = usePageState();
    const dirwebLongClasses = useStyles();
    const { tenant } = useTenant();
    const headerIcons = tenant?.formIcons || [];
    const headerIcon = headerIcons.find(icon => icon.name === headerIconName);
    const intl = useIntl();
    return (_jsx(_Fragment, { children: _jsxs(Grid, { container: true, className: clsx(dirwebLongClasses.root), justifyContent: "center", children: [!stepper && (_jsx(Grid, { item: true, xs: 12, md: 8, children: _jsx(DirwebStepper, { step: step }) })), headerIcon && (_jsx(Grid, { container: true, item: true, xs: 12, md: 8, justifyContent: "center", children: _jsx("img", { src: headerIcon.icon, className: dirwebLongClasses.headerIcon, alt: headerIcon.description
                            ? intl.formatMessage(headerIcon.description)
                            : "Header icon" }) })), (props.pageTitle || props.description) && (_jsxs(Grid, { item: true, xs: 12, md: 8, className: dirwebLongClasses.header, children: [props.pageTitle && (_jsx(Typography, { variant: "h2", gutterBottom: true, className: dirwebLongClasses.titleText, tabIndex: -1, children: props.pageTitle })), props.description && (_jsx(Typography, { color: "textSecondary", variant: "body1", children: description }))] })), main && (_jsx(Grid, { item: true, xs: 12, md: 8, className: clsx(dirwebLongClasses.mainGrid), children: _jsxs(Grid, { item: true, xs: 12, md: true, children: [_jsx(ThemeProvider, { theme: mainTheme, children: _jsx(Panel, { ...main, transparent: true }) }), _jsx(ThemeProvider, { theme: actionsTheme, children: _jsx(Panel, { ...actions, transparent: true }) })] }) }))] }) }));
};
DirwebLong.displayName = "DployFormDirwebLong";
//# sourceMappingURL=DirwebLong.js.map